import { getObjectLength } from './sorted-object';

// 一つ前の大見出しを探す
export const getPrevGroupStartIndex = (body, inputs, startIndex) => {
  for (let i = startIndex - 1; i > 0; i--) {
    const el = findInputElement(body, inputs, i);
    console.log(el);
    if (body[i].action === 'header' && el.type === 'h2') {
      return i;
    }
  }
  return 0;
};

//　次の大見出しを探す
const getNextGroupStartIndex = (body, inputs, startIndex) => {
  for (let i = startIndex + 1; i < getObjectLength(body); i++) {
    const el = findInputElement(body, inputs, i);
    if (body[i].action === 'header' && el.type === 'h2') {
      return i;
    }
  }
  return getObjectLength(body) - 1;
};

// 次のグループの終わりを探す
export const getNextGroupEndIndex = (body, inputs, startIndex) => {
  const nextGroupStartIndex = getNextGroupStartIndex(body, inputs, startIndex);
  return getGroupEndIndex(body, inputs, nextGroupStartIndex);
};

export const findInputElement = (body, inputs, index) => {
  return inputs.find((input) => input.id === body[index].id);
};

export const getGroupEndIndex = (body, inputs, startIndex) => {
  const target = body[startIndex];
  // 大見出し以外はまとめて移動機能は利用不可
  if (!target || target.action !== 'header' || target.value.type !== 'h2') {
    return undefined;
  }

  for (let i = startIndex + 1; i < getObjectLength(body); i++) {
    const el = findInputElement(body, inputs, i);
    if (body[i].action === 'header' && el.type === 'h2') {
      return i - 1;
    }
  }
  return getObjectLength(body) - 1;
};

export const confirmTargetGroup = async (refs, body, startIndex, endIndex) => {
  setColor(refs, body, startIndex, endIndex, '#b0c4de');
  await new Promise((resolve) => setTimeout(resolve, 300));
  const ok = window.confirm('このグループを移動しますか？');
  if (ok) {
    return true;
  }

  setColor(refs, body, startIndex, endIndex, false);
  return false;
};

export const setColor = (refs, body, startIndex, endIndex, color) => {
  for (let i = startIndex; i <= endIndex; i++) {
    const el = refs.inputs.find((input) => input.id === body[i].id).$el;
    el.style.backgroundColor = color ? color : '';
  }
};
